import React from 'react';

const Error403 = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-gray-800 via-gray-900 to-black text-white">
    <h1 className="text-6xl font-bold mb-4">403</h1>
    <p className="text-xl mb-8">Access Denied. You don't have permission to view this page.</p>
    <a href="/" className="px-6 py-3 bg-gray-600 hover:bg-gray-700 rounded-full text-lg font-medium shadow-md transition-transform hover:scale-105">Go Home</a>
  </div>
);

export default Error403;
